const adjectives = [
  'aged',
  'ancient',
  'autumn',
  'billowing',
  'bitter',
  'black',
  'blue',
  'bold',
  'broad',
  'broken',
  'calm',
  'cold',
  'cool',
  'crimson',
  'curly',
  'damp',
  'dark',
  'dawn',
  'delicate',
  'divine',
  'dry',
  'empty',
  'falling',
  'fancy',
  'flat',
  'floral',
  'fragrant',
  'frosty',
  'gentle',
  'green',
  'hidden',
  'holy',
  'icy',
  'jolly',
  'late',
  'lingering',
  'little',
  'lively',
  'long',
  'lucky',
  'misty',
  'morning',
  'muddy',
  'mute',
  'nameless',
  'noisy',
  'odd',
  'old',
  'orange',
  'patient',
  'plain',
  'polished',
  'proud',
  'purple',
  'quiet',
  'rapid',
  'raspy',
  'red',
  'restless',
  'rough',
  'round',
  'royal',
  'shiny',
  'shrill',
  'shy',
  'silent',
  'small',
  'snowy',
  'soft',
  'solitary',
  'sparkling',
  'spring',
  'square',
  'steep',
  'still',
  'summer',
  'super',
  'sweet',
  'throbbing',
  'tight',
  'tiny',
  'twilight',
  'wandering',
  'weathered',
  'white',
  'wild',
  'winter',
  'wispy',
  'withered',
  'yellow',
  'young',
  'amber',
  'azure',
  'bright',
  'bronze',
  'copper',
  'crystal',
  'dusty',
  'emerald',
  'fading',
  'fierce',
  'floating',
  'foggy',
  'golden',
  'graceful',
  'heavy',
  'humble',
  'ivory',
  'jade',
  'light',
  'maroon',
  'mellow',
  'navy',
  'pale',
  'peaceful',
  'pink',
  'precious',
  'quick',
  'rustic',
  'scarlet',
  'silver',
  'smooth',
  'stark',
  'sunny',
  'teal',
  'tender',
  'turquoise',
  'velvet',
  'violet',
  'warm',
  'wooden',
];

const nouns = [
  'art',
  'band',
  'bar',
  'base',
  'bird',
  'block',
  'boat',
  'bonus',
  'bread',
  'breeze',
  'brook',
  'bush',
  'butterfly',
  'cake',
  'cell',
  'cherry',
  'cloud',
  'credit',
  'darkness',
  'dawn',
  'dew',
  'disk',
  'dream',
  'dust',
  'feather',
  'field',
  'fire',
  'firefly',
  'flower',
  'fog',
  'forest',
  'frog',
  'frost',
  'glade',
  'glitter',
  'grass',
  'hall',
  'hat',
  'haze',
  'heart',
  'hill',
  'king',
  'lab',
  'lake',
  'leaf',
  'limit',
  'math',
  'meadow',
  'mode',
  'moon',
  'morning',
  'mountain',
  'mouse',
  'mud',
  'night',
  'paper',
  'pine',
  'poetry',
  'pond',
  'queen',
  'rain',
  'recipe',
  'resonance',
  'rice',
  'river',
  'salad',
  'scene',
  'sea',
  'shadow',
  'shape',
  'silence',
  'sky',
  'smoke',
  'snow',
  'snowflake',
  'sound',
  'star',
  'sun',
  'sun',
  'sunset',
  'surf',
  'term',
  'thunder',
  'tooth',
  'tree',
  'truth',
  'union',
  'unit',
  'valley',
  'violet',
  'voice',
  'water',
  'waterfall',
  'wave',
  'wildflower',
  'wind',
  'wood',
  'garden',
  'stream',
  'crystal',
  'pebble',
  'ocean',
  'meadow',
  'canyon',
  'desert',
  'island',
  'jungle',
  'lagoon',
  'oasis',
  'reef',
  'spring',
  'summit',
  'cave',
  'cliff',
  'coast',
  'coral',
  'delta',
  'dune',
  'grove',
  'harbor',
  'marsh',
  'peak',
  'plain',
  'shore',
  'swamp',
  'temple',
  'tower',
  'trail',
  'bridge',
  'castle',
  'cottage',
  'fountain',
  'gate',
  'lodge',
  'manor',
  'palace',
  'portal',
  'shrine',
  'spire',
  'villa',
  'beacon',
  'ember',
  'flame',
  'lantern',
  'prism',
  'spark',
  'torch',
];

export function getRandomFileName(separator = '-') {
  const adjective = randomValueFromArray(adjectives);
  const noun = randomValueFromArray(nouns);

  return `${adjective}${separator}${noun}`;
}

function randomValueFromArray(array: any[]) {
  return array[Math.floor(array.length * Math.random())];
}
